
import {
  describeColorTemperature,
  withoutColorTemperatureSpecifications,
} from '@/utils/colorTemperature'
import { formatSpecRange, variantSpecRange } from '@/utils/variantSpecRange'

export default {
  name: 'ProductListItemSpecs',
  props: {
    variant: {
      type: Object,
      default: null,
    },
    maxSpecs: {
      type: Number,
      default: 5,
    },
    ranges: {
      type: Object,
      default: null,
    },
  },
  computed: {
    essentialSpecs() {
      const specs = []
      const variant = this.variant
      if (!variant) return specs

      const watts = this.ranges
        ? this.ranges.watts
        : variantSpecRange([variant], 'watts')
      const lumens = this.ranges
        ? this.ranges.lumens
        : variantSpecRange([variant], 'lumens')

      if (watts) {
        specs.push({
          label: this.$t('components.productListItem.specPower'),
          value: formatSpecRange(watts, ' W'),
        })
      }
      if (lumens) {
        specs.push({
          label: this.$t('components.productListItem.specLuminosity'),
          value: formatSpecRange(lumens, ' lm'),
        })
      }
      if (variant.color_temperature) {
        specs.push({
          label: this.$t('pages.produit.slug.colorTemperature'),
          value: describeColorTemperature(variant),
          kelvin: variant.color_temperature,
        })
      }
      if (Array.isArray(variant.specification_values_featured)) {
        withoutColorTemperatureSpecifications(
          variant.specification_values_featured,
          variant
        ).forEach(spec => {
          if (
            spec.is_featured &&
            spec.specification &&
            spec.specification.name
          ) {
            specs.push({ label: spec.specification.name, value: spec.value })
          }
        })
      }
      return specs.slice(0, this.maxSpecs)
    },
  },
}
